import { init } from "../lib/es6_global/src/Tracker.bs";

// We store a copy of the fetch function in window.makerFetch
// This is to avoid the fetch function being overwritten by other scripts
// Very common for other trackers on the page to overwrite it.
window.makerFetch = window.makerFetch || window.fetch;

init();
